export default () => {
  const updateTitle = (newTitle: string) => {
    console.log(newTitle, "newTitlenewTitlenewTitle");
    document.title = newTitle || "账三丰";
  };

  const updateFavicon = (newFaviconPath: string) => {
    console.log(newFaviconPath, "newFaviconPathnewFaviconPath");
    const url = newFaviconPath || "./favicon.ico";
    const link: any = document.querySelector("link[rel*='icon']");
    link.rel = "icon";
    link.href = url + "?" + new Date().getTime();
    document.getElementsByTagName("head")[0].appendChild(link);
  };

  return {
    setTitle: updateTitle,
    updateFavicon: updateFavicon,
  };
};
